import { ParagraphFonts } from "@tvg/design-system/web";
import formatSequencial from "@tvg/formatter/numeric";
import { InlinePastPerformanceResultRunners } from "../../../../types";
import { formatBeatenDistance } from "../../../../hooks/useCurrentRaceResultRunners";

export const getOdds = (runner: InlinePastPerformanceResultRunners | null) => {
  if (runner && runner.currentOdds?.numerator) {
    const { currentOdds } = runner;
    return `${currentOdds.numerator}${
      currentOdds.denominator ? `/${currentOdds.denominator}` : ""
    }`;
  }

  return "n/a";
};

export const getLength = (
  beatenDistance: string | null | undefined,
  beatenDistanceStatus: string | null | undefined
) => {
  const beatenDistanceLabel =
    !beatenDistance || !beatenDistanceStatus
      ? ""
      : ` ${formatBeatenDistance(beatenDistance, beatenDistanceStatus)}`;
  return beatenDistanceLabel;
};

export const getPosition = (
  runner: InlinePastPerformanceResultRunners | null,
  numRunners: string
) => {
  const position = `/${numRunners}`;

  if (!runner || !runner.finishPosition) return `-${position}`;

  return `${formatSequencial(runner.finishPosition)}${position}`;
};

export const getFontFamily = (
  valueA: string | undefined,
  valueB: string | undefined
): ParagraphFonts => (valueA === valueB ? "bold" : "regular");
